import { render } from "./KoruBrowser.vue?vue&type=template&id=7627c384&ts=true"
import script from "./KoruBrowser.vue?vue&type=script&lang=ts"
export * from "./KoruBrowser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__